import * as React from 'react'

import { Switch } from '~/client/src/shared/components/shadcn-ui/switch'
import Localization from '~/client/src/shared/localization/LocalizationManager'

interface IShowInAppCellProps {
  isEnabled: boolean
  onChange: () => void
}

export default function ShowInAppCell({
  isEnabled,
  onChange,
}: IShowInAppCellProps): React.ReactElement {
  return (
    <span
      className="tw:flex tw:items-center"
      onClick={event => event.stopPropagation()}
    >
      <Switch
        checked={isEnabled}
        onCheckedChange={() => onChange()}
        aria-label={Localization.translator.allowCreation}
      />
    </span>
  )
}
